import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-info",
  "use": "icon-info-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" aria-labelledby=\"infoIconTitle\" stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-linejoin=\"miter\" fill=\"none\" id=\"icon-info\"> <title id=\"icon-info_infoIconTitle\">Information</title> <path d=\"M12,12 L12,15\" /> <line x1=\"12\" y1=\"9\" x2=\"12\" y2=\"9\" /> <circle cx=\"12\" cy=\"12\" r=\"10\" /> </symbol>"
});
var result = sprite.add(symbol);
export default symbol